import BrokenRolls from "@/pages/rollshop/pages/broken_rolls";
import RollshopNotification from "@/pages/rollshop/pages/notifications";
import Operation from "@/pages/rollshop/pages/operations";
import Rollset from "@/pages/rollshop/pages/rollsets";
import Spare from "@/pages/rollshop/pages/spare";

export const routeRollsets = "rollshop/rollsets";
export const routeRollshopNotifications = "rollshop/notifications";
export const routeBrokenRolls = "rollshop/broken-rolls";

export const rollshopRoutes = [
	{
		path: "/spare",
		element: <Spare />,
		permission: "ui.navbar.rollshop.spare",
	},
	{
		path: routeRollsets,
		element: <Rollset />,
		permission: "ui.navbar.rollshop.rollsets",
	},
	{
		path: `${routeRollsets}/:sectionId`,
		element: <Rollset />,
		permission: "ui.navbar.rollshop.rollsets",
	},
	{
		path: routeRollshopNotifications,
		element: <RollshopNotification />,
		permission: "ui.navbar.rollshop.notifications",
	},
	{
		path: `${routeRollshopNotifications}/:shiftId`,
		element: <RollshopNotification />,
		permission: "ui.navbar.rollshop.notifications",
	},
	{
		path: routeBrokenRolls,
		element: <BrokenRolls />,
	},

	{
		path: "/rollshop-operations",
		element: <Operation />,
		permission: "ui.navbar.rollshop.operations",
	},
	{
		path: "/rollshop-operations/:partId",
		element: <Operation />,
		permission: "ui.navbar.rollshop.operations",
	},
];
